import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, IdDescription } from '../../../tms-shared';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class FabricProcessingFabricReferenceService extends BaseReferenceService {
  constructor(protected httpService: HttpService) {
    super('FabricProcessingFabricReference', httpService);
  }

  getForFabric(productId: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForFabric/${productId}`);
  }
}
